import React from 'react';
import { UserGroup } from 'models/user-management';
import { useAuthUserSelector, useDialog, useForm, useFormActionLoader, useFormEditToogleActions } from 'hooks';
import { canEditUserGroup, canRefreshUserGroupAccessCode } from 'utils/permissions';
import { RefreshUserGroupAccessCode, UpdateUserGroup } from 'actions/user-management';
// components
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { UserGroupForm, UserGroupFormField } from 'components/UserManagement';
import { RefreshAccessCodeDialog } from './RefreshAccessCodeDialog';

interface Props {
  userGroup: UserGroup;
}

export const UserGroupManagment = ({ userGroup }: Props): JSX.Element => {
  const user = useAuthUserSelector();
  const form = useForm<UserGroup, UserGroupFormField>({
    initialState: userGroup,
    showFields: [
      UserGroupFormField.name,
      UserGroupFormField.address,
      UserGroupFormField.phone_number,
      UserGroupFormField.client_access_code,
    ],
  });
  const refreshAccessCodeDialog = useDialog();
  const { doAction } = useFormActionLoader();
  const { editMode, actions } = useFormEditToogleActions({
    canEdit: canEditUserGroup(user),
    canSave: form.isChange,
    onSave: () => {
      if (!form.validate()) {
        return false;
      }

      doAction({
        action: UpdateUserGroup(form.state),
        onError: form.catchError,
      });
    },
    onCancel: form.reset
  });

  const handleRefreshAccessCode = () => doAction({
    action: RefreshUserGroupAccessCode(userGroup),
  });

  return (
    <Card>
      <CardHeader title={ `Client ${ userGroup.name }` } action={
        <>
          { actions }
        </>
      }/>
      <CardContent>
        <UserGroupForm
          isView={ !editMode }
          { ...form }
          disabledFields={ [UserGroupFormField.client_access_code] }
          onRefreshAccessCode={ canRefreshUserGroupAccessCode(user) ? handleRefreshAccessCode : undefined }
        />
      </CardContent>
      { refreshAccessCodeDialog.isMounted && <RefreshAccessCodeDialog
        userGroup={ userGroup }
        isOpen={ refreshAccessCodeDialog.isOpen }
        onClose={ refreshAccessCodeDialog.close }
        onCloseEnd={ refreshAccessCodeDialog.unmount }
        onConfirm={ handleRefreshAccessCode }
      /> }
    </Card>
  );
};

